<script>
import {onMount } from 'svelte';
import {supabase} from "./supabaseClient"

onMount(async () => {
  const urlParams = new URLSearchParams(window.location.search)
  let boardName = urlParams.get('BoardName')

  let { data, error } = await supabase
   .rpc('create_board', {
     title:boardName
   })
 if (error) console.error(error)
 else console.log(data)

 window.location.href = '/board?accessKey=' + data.access_key + '&trialBoard=yes'

})
</script>

Loading....
